import { useAlert } from '@rahtab/ui/dist/components/Alert';
import { NavigationProp, useNavigation } from '@react-navigation/native';
import { RootStackType } from 'components/Router';
import { useEffect } from 'react';
import useRequest, { FetchFn, FetchResult } from './useRequest';

interface VetApproveRequestData {
  requestCode: string;
  reqAmount: string;
  vetApproveAmount: string;
  receivedDate: string;
  itemCount: number;
}

interface VetApproveRequest {
  result: boolean;
  error: string;
  message: string;
}

function useVetApproveRequest(
  data: VetApproveRequestData,
  fromHistory?: boolean,
): [FetchFn, FetchResult<VetApproveRequest>] {
  const { goBack, navigate } = useNavigation<NavigationProp<RootStackType>>();
  const formData = new FormData();
  formData.append('ApproveInfo', JSON.stringify(data));
  const alert = useAlert();
  const [vetApproveRequest, result] = useRequest<VetApproveRequest>('VetApproveRequest', {
    data: formData,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    skip: true,
  });

  useEffect(() => {
    if (result.data) {
      const { error, message, result: success } = result.data;
      const buttons = [
        {
          color: 'secondary',
          variant: 'outlined',
          text: 'بازگشت',
          onPress: () => {
            if (fromHistory) {
              navigate('VerifiedLoadsHistory', { refetch: true });
            } else {
              goBack();
            }
          },
        } as const,
      ];
      if (!success) buttons.pop();
      alert({
        title: 'پیام سیستم',
        message: success ? message : error,
        severity: success ? 'success' : 'error',
        hideBackButton: success,
        buttons,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result.data?.result]);
  return [vetApproveRequest, result];
}

export default useVetApproveRequest;
